import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfigureSettingsRoutingModule } from './configure-settings-routing.module';
import { ConfigureSettingsComponent } from './configure-settings.component';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {CardiConfigLoginSettingsModule} from '@pics-core/config-login-settings'
@NgModule({
  declarations: [ConfigureSettingsComponent],
  imports: [CommonModule, ConfigureSettingsRoutingModule, PrimengModule,
     ReactiveFormsModule, FormsModule,CardiConfigLoginSettingsModule]
})
export class ConfigureSettingsModule {}
